import { Link } from "react-router-dom";

const HavnsLogo = ({ className = "", linkTo = "/", size = "default" }) => {
  // Size variants for different contexts  
  // Using larger height to compensate for the extra space in the image
  const sizes = {
    small: { height: 80, displayHeight: 32 },
    default: { height: 110, displayHeight: 44 },
    large: { height: 140, displayHeight: 56 },
  };
  
  const { height, displayHeight } = sizes[size] || sizes.default;
  
  return (
    <Link 
      to={linkTo} 
      className={`inline-flex items-center no-underline ${className}`} 
      data-testid="havns-logo"
      style={{
        height: `${displayHeight}px`,
        overflow: 'hidden',
      }}
    >
      <img 
        src="https://customer-assets.emergentagent.com/job_3fb92393-533d-48ba-9851-1af920d68ded/artifacts/ya5y4twl_download-removebg-preview.png"
        alt="Havns"
        style={{ 
          height: `${height}px`, 
          width: 'auto',
          marginTop: '-30%',
          marginBottom: '-30%',
        }}
        className="object-contain"
      />
    </Link>
  );
};

export default HavnsLogo;
